import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate, useParams } from 'react-router';
import { getJobs } from '../../store/slices/jobSlice';
import { formattedDateTime } from '../../store/slices/jobSlice';
import Can from '../../permission/Can';

const JobList = () => {
    const navigate = useNavigate();
    const { agentId } = useParams();
    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user_id',
            key: 'user_id',
            render: (_, data) => {
                return `${data?.user_id?.first_name} ${data?.user_id?.last_name}`
            }
        },
        {
            title: 'Agent Name',
            dataIndex: 'agent_id',
            key: 'agent_id',
            render: (_, data) => {
                return data?.agent_id ? `${data?.agent_id?.first_name} ${data?.agent_id?.last_name}` : 'N/A'
            }
        },
        {
            title: 'Categorization',
            dataIndex: 'categorization',
            key: 'categorization',
        },
        {
            title: 'Job Start Time',
            dataIndex: 'job_start_time',
            key: 'job_start_time',
            render : (_, data) => {
                if (data?.job_start_time) {
                    const date = new Date(data?.job_start_time);
                    return formattedDateTime(date)
                } else {
                    return "N/A";
                }
            }
        },
        {
            title: 'Job End Time',
            dataIndex: 'job_end_time',
            key: 'job_end_time',
            render : (_, data) => {
                if (data?.job_end_time) {
                    const date = new Date(data?.job_end_time);
                    return formattedDateTime(date)
                } else {
                    return "N/A";
                }
            }
        },
        {
            title: 'Job Date',
            dataIndex: 'job_date',
            key: 'job_date',
            render : (_, data) => {
                const date = new Date(data?.job_date);
                return date.toLocaleDateString('en-CA')
            }
        },
        {
            title: 'Status',
            dataIndex: 'job_step',
            key: 'job_step',
        },
        {
            title: 'Time Slot',
            dataIndex: 'time_slot',
            key: 'time_slot',
        },
        {
            title: 'Creation Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            // defaultSortOrder: 'descend',
            sortDirections: ['ascend', 'descend'],
            render : (_, data) => {
                const date = new Date(data?.createdAt);
                return date.toLocaleDateString('en-CA')
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/job/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
                    <Can permission="edit_job">
                        <Button onClick={() => navigate('/job/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    </Can>
                    {/* <Button icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
                </Space>
            ),
        },
    ];

    const searchData = {
        agentId : agentId
    }

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Jobs</h1>
                <Can permission="create_job">
                    {!agentId && (
                        <Button type="primary" onClick={() => navigate('/job/add')}>Add Job</Button>
                    )}
                </Can>
            </div>
            <TableComponent
                listData={getJobs}
                columns={columns}
                placeholder="Search job..."
                searchData={searchData}
                listName="Job"
            />
        </div>
    );
};

export default JobList;
